(function () {
    'use strict';

    var $ = window.jQuery;
    var data = {};

    function VideoArchive() {

        this.options = $.extend({}, VideoArchive.defaults);
        this.initSelect();
    }

    VideoArchive.prototype.initSelect = function () {
        var $self = this;

        $('#sport_category').on('change', function (event) {
            event.preventDefault();

            var sport_category = $(this).val();


            if (!sport_category) {
                delete data.sportcategory;
            } else {
                data.sportcategory = sport_category;
            }
            $self.makeRequest(true);
        });

        $('#filter2').on('change', function (event) {
            event.preventDefault();

            var order = $(this).val();

            if (!order) {
                delete data.order;
            } else {
                data.order = order;
            }
            $self.makeRequest(true);
        });

        $('#filter').on('change', function (event) {
            event.preventDefault();

            var videotype = $(this).val();

            if (!videotype) {
                delete data.videotype;
            } else {
                data.videotype = videotype;
            }
            $self.makeRequest(true);
        });

        $('#searchform').on('submit', function (event) {
            event.preventDefault();

            var search_value = $('#search');

            if (search_value.val()) {
                $self.resetSelects();
                data.search = search_value.val();
                $self.makeRequest(true);
            } else {
                delete data.search;
            }
        });

        $('#load-more-videos').on('click', function () {
            event.preventDefault();
            data.offset = $('#load-more-videos').data('offset');
            $self.makeRequest(false);
        });
    };

    VideoArchive.prototype.makeRequest = function (replace_content) {
        var $self = this,
            $load_more_button = $($self.options.load_more_button),
            $content_container = $('#infinite-container');

        return $.ajax({
            type: 'GET',
            url: $self.options.api_url,
            data: data,
            beforeSend: function()
            {
                $load_more_button.addClass('isDisabled').prop('disabled', true);
            },
            success: function (response) {
                if (response.count > 0 || replace_content === true) {
                    if (replace_content === true) {
                        if (response.count === 0 && response.message) {
                            $content_container.empty().append('<h1 class="text-center">' + response.message + '</h1>');
                        } else {
                            $content_container.empty().append(response.data);
                        }
                    } else {
                        $content_container.append(response.data);
                        var current_offset = $load_more_button.data('offset');
                        $load_more_button.data('offset', current_offset + response.count);
                    }

                    $load_more_button
                        .prop('disabled', false)
                        .removeClass('isDisabled');
                }

                if (response.count < $self.options.limit_per_request) {
                    $load_more_button.fadeOut();
                } else {
                    $load_more_button.fadeIn();
                }
            },
            error: function () {
                $('#nextVideos').fadeOut();
            }
        });
    };

    VideoArchive.prototype.resetSelects = function () {
        $('#filter2').prop('selectedIndex', 0);
        $('#filter').prop('selectedIndex', 0);
        $('#sport_category').prop('selectedIndex', 0);
        delete data.order;
        delete data.videotype;
        delete data.sportcategory;
    };

    VideoArchive.defaults = {
        api_url: '/wp-json/arkansas/v2/load_videos',
        load_more_button: '#load-more-videos'
    };

    window.VideoArchive = VideoArchive;

}());